import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import NetworkRequest from "../../../config/network";
import configuration from "../../../config/configuration";
import {
  apiResponseInitialState,
  apiresponseType,
  getParametersHeaderPost,
} from "src/config/helper";

export const login = createAsyncThunk(
  "loginDetails",
  async ({ values, tenantName }: { values: {}; tenantName: string }) => {
    try {
      
      const response = await NetworkRequest.post(
        configuration.apis.login,
        values,
        getParametersHeaderPost({ tenantId: tenantName }),
      );
      if (response?.data?.status === true) {
        const resultData = response.data;
        localStorage.setItem(
          "userDetails",
          JSON.stringify(resultData?.data?.auth),
        );
      localStorage.setItem("isAuthorized", "true");
        localStorage.setItem(
          "homePageDetails",
          JSON.stringify(resultData?.data?.dataList?.[0]?.courseDetails?.[0]?.data || []),
        );
        return resultData;
      } else {
        const resultData = response.data;
        return resultData;
      }
    } catch (err) {
      console.log(err);
    }
  },
);

interface loginDetailsState {
  loginDetails: apiresponseType;
  loading: boolean;
  error: any;
}

const loginDetailsInitalState: loginDetailsState = {
  loginDetails: apiResponseInitialState,
  loading: false,
  error: {},
} satisfies loginDetailsState as loginDetailsState;

const loginDetailsSlice = createSlice({
  name: "loginDetails",
  initialState: loginDetailsInitalState,

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state, action) => {
        state.loading = true;
        state.error = {};
        state.loginDetails = apiResponseInitialState;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.error = "";
        state.loginDetails = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loginDetails = apiResponseInitialState;
      });
  },
});

export default loginDetailsSlice.reducer;
